import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { BaseCardComponent } from './BaseCardComponent';

interface HistoricalFunFactsProps {
  historicalFunFacts?: string[];
}

export function HistoricalFunFacts({
  historicalFunFacts,
}: HistoricalFunFactsProps) {
  return (
    <BaseCardComponent title="Historical Significance">
      <Stack spacing={2} alignItems="flex-start">
        {historicalFunFacts?.map((fact) => (
          <Text key={fact} variant="body2">
            {fact}
          </Text>
        ))}
      </Stack>
    </BaseCardComponent>
  );
}
